// extracted by mini-css-extract-plugin
export default {"wrapper":"w5Oxsj","line":"e2dXGS"};